var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102.13 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#130b61;}.cls-2{fill:#2b3990;}.cls-3{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tobi"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 5.87,
    width: 102.13,
    height: 102.13,
    rx: 7.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 102.13,
    height: 102.13,
    rx: 7.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.78,53.42H82.34V75.51a1.8,1.8,0,0,1-1.8,1.79H57.25V65.17a4.12,4.12,0,0,0-4.1-4.11H49.83a4.11,4.11,0,0,0-4.1,4.11V77.3H22.79A1.8,1.8,0,0,1,21,75.51V53.42H15.35a1.8,1.8,0,0,1-1-3.27L50,25.28a1.79,1.79,0,0,1,2,0L87.81,50.15A1.8,1.8,0,0,1,86.78,53.42Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset10);
export default __webpack_public_path__ + "static/media/asset10.d15f19cc9d5b5de3602227f073503f27.svg";
export { ForwardRef as ReactComponent };